import {NGXLogger} from 'ngx-logger';
import * as Highcharts from 'highcharts';
const userLocale = navigator.language;

export const DefaultHChartProperties: any = {
  height: 700,
  width: 1500,
  spacingLeft: 20,
  spacingRight: 40,

  exporting: {
    local: true,
    enabled: true,
    fallbackToExportServer: false,
    buttons: {
      contextButton: {
        enabled: true,
      },
    },
  },

  time: {
    timezone: 'Europe/Amsterdam',
    // useUTC: false,
  },

  title: {
    text: 'Height of Tide',
  },

  tooltip: {
    shared: true,
    xDateFormat: '%Y-%m-%d %H:%M:%S',
  },

  chart: {
    spacingLeft: 20,
    spacingRight: 40,
    spacingBottom: 30,

    style: {
      fontFamily: 'Helvetica Neue',
    },
  },

  plotOptions: {
    series: {
      dataGrouping: {
        enabled: false,
      },
      states: {
        // disable the line thickening when whe hover over it
        hover: {
          lineWidthPlus: 0,
        },
      },
      marker: {
        // disable dots on every entry in the line
        enabled: false,
        states: {
          // but enable them on hover
          hover: {
            enabled: true,
            radius: 2,
          },
        },
      },
    },
  },

  legend: {
    y: 50,
    verticalAlign: 'top',
    enabled: true,
  },

  navigator: {
    enabled: true,
    adaptToUpdatedData: false,
    xAxis: {
      labels: {
        formatter: function () {
          if (Highcharts.dateFormat('%H:%M', this.value) === '00:00') {
            return new Intl.DateTimeFormat(userLocale, {
              day: 'numeric', month: 'short',
            }).format(this.value);
          }
          return Highcharts.dateFormat('%H:%M', this.value);
        },
      },
    },
  },

  scrollbar: {
    liveRedraw: true,
  },

  series: null,

  xAxis: {
    type: 'datetime',
    ordinal: false,
    labels: {
      formatter: function () {
        if (Highcharts.dateFormat('%H:%M', this.value) === '00:00') {
          return new Intl.DateTimeFormat(userLocale, {
            day: 'numeric', month: 'short',
          }).format(this.value);
        }
        return Highcharts.dateFormat('%H:%M', this.value);
      },
      style: {
        color: '#666',
        fontSize: '11px',
      },
      // format: '{value:%H:%M}',
    },
    title: {
      text: 'Time',
    },
    lineColor: '#ccd6eb',
    tickColor: '#ccd6eb',
  },

  rangeSelector: {
    x: 0,
    y: -3,
    inputEnabled: true,
    selected: 1,
    buttons: [
      {
        type: 'all',
        text: 'All',
      },
      {
        type: 'hour',
        count: 1,
        text: '1H',
      },
      {
        type: 'hour',
        count: 6,
        text: '6H',
      },
      {
        type: 'hour',
        count: 12,
        text: '12H',
      },
      {
        type: 'hour',
        count: 24,
        text: '1D',
      },
      {
        type: 'hour',
        count: 48,
        text: '2D',
      },
    ],
  },

  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 1100,
        },
        chartOptions: {
          rangeSelector: {
            align: 'left',
            y: 43,
          },
          legend: {
            align: 'right',
            y: 39,
          },
        },
      },
    ],
  },

  yAxis: [{ // Observations chart.
    opposite: false,
    labels: {
      align: 'right',
      x: -3,
      format: '{value}',
      style: {
        color: '#666',
        fontSize: '11px',
      },
    },
    title: {
      text: 'value',
    },
    height: '80%',
    lineWidth: 2,
    lineColor: '#ccd6eb',
    resize: {
      enabled: true,
    },
  },
  { // Checks chart.
    labels: {
      enabled: false,
      align: 'right',
      x: -3,
      formatter() {
        return this.value;
      },
      style: {
        color: '#666',
        fontSize: '11px',
      },
    },
    title: {
      text: 'Checks',
    },
    top: '85%',
    height: '15%',
    offset: 0,
    lineColor: '#ccd6eb',
    lineWidth: 2,
  }],
};
